export default __webpack_public_path__ + "static/media/WF-white.b1093adb.svg";